import { handleActions } from 'redux-actions';

const initialState = {};

const reducer = handleActions({}, initialState);

export default reducer;
